import { UploadLayout } from 'src/app/models/settings.model';
import { Injectable, Renderer2, Inject, RendererFactory2 } from '@angular/core';
import { LayoutFile } from '../models/settings.model';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { map } from 'jquery';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  readonly rootURL = environment.ImpataAppAPIRoot;
  // private renderer: Renderer2;

  private layoutFiles: LayoutFile[] = undefined;
  constructor(
    private http: HttpClient,
    // rendererFactory: RendererFactory2,
    // @Inject(DOCUMENT) private document: Document,
    private sanitizer: DomSanitizer
  ) {
    // this.renderer = rendererFactory.createRenderer(null, null);
  }

  async UploadLayoutFile(data: any) {
    return this.http
      .post(this.rootURL + `customization/uploadcustomslayout`, data, {
        headers: new HttpHeaders({
          'Content-Disposition': 'multipart/form-data',
        }),
      })
      .toPromise();
  }
  /**
   * Fetches the contents of an uploaded layout file.
   *
   * Stylesheets are handed to a <link> tag by URL, but an HTML layout has to be read and
   * put into the page, so we need the text rather than the address.
   */
  async getLayoutFileContent(fileUrl: string): Promise<string> {
    return this.http.get(fileUrl, { responseType: 'text' }).toPromise();
  }

  async getLayouts(data: any) {
    return this.http
      .get(this.rootURL + `customization/getcustomslayouts?schoolId=${data}`)
      .toPromise();
  }
  async deleteLayout(data: any) {
    return this.http
      .delete(this.rootURL + `customization/deletecustomlayout?id=${data}`)
      .toPromise();
  }

  async UploadImgFiles(data: any) {
    return this.http
      .post(this.rootURL + `customization/uploadimgs`, data, {
        headers: new HttpHeaders({
          'Content-Disposition': 'multipart/form-data',
        }),
      })
      .toPromise();
  }

  async getLayoutImages(data: any) {
    return this.http
      .get(this.rootURL + `customization/getcustomslayoutimages?schoolId=${data}`)
      .toPromise();
  }
  async deleteLayoutImage(data: any) {
    return this.http
      .delete(this.rootURL + `customization/deletecustomlayoutimage?id=${data}`)
      .toPromise();
  }

  async getLayoutFiles(schId) {
    if (this.layoutFiles === undefined) {
      this.layoutFiles = await this.getLayouts(schId).then(
        (res: LayoutFile[]) => {
          return res;
        }
      );
    }
    return this.layoutFiles;
  }


  async UploadCertificate(data: any) {
    return this.http
      .post(this.rootURL + `customization/uploadcustomcertificate`, data, {
        headers: new HttpHeaders({
          'Content-Disposition': 'multipart/form-data',
        }),
      })
      .toPromise();
  }

  async getCertificateFiles(data: any) {
    return this.http
      .get(this.rootURL + `customization/getcustomcertificates?schoolId=${data}`)
      .toPromise();
  }

  async deleteCertificateFile(data: any) {
    return this.http
      .delete(this.rootURL + `customization/deletecustomcertificate?id=${data}`)
      .toPromise();
  }

  async markCertificateFileInUse(id: number) {
    return this.http
      .put(this.rootURL + `customization/markcertificateinuse?id=${id}`,id)
      .toPromise();
  }

  async getCertificateTemplate() {
    return this.http
      .get(this.rootURL + `customization/getcertificatetemplate`)
      .toPromise();
  }
  async testCertificateTemplate(schoolid:number,certificateid:number) {
    return this.http
      .get(this.rootURL + `customization/testcertificate?schoolId=${schoolid}&certificateId=${certificateid}`)
      .toPromise();
  }
  // loadCss(url: string) {
  //   debugger;
  //   const linkElement = this.renderer.createElement('link');
  //   linkElement.rel = 'stylesheet';
  //   linkElement.href = url;

  //   this.renderer.appendChild(this.document.head, linkElement);
  // }

}
